import React from "react";
import { StickyTopRowStack } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import StoreFilter from "../../../../components/commonComponents/Filters/StoreFilter";

const TotalMonitoringFilter = () => {
  return (
    <StickyTopRowStack direction={"row"} spacing={4}>
      {/* ------- stores filter ----------- */}
      <Box sx={{ width: 220 }}>
        <StoreFilter
          usedFor={"receipt-monitoring"}
          reduxKeywordToSaveValue={"embedded_total_monitoring_stores"}
          fetchListFor="independent"
        />
      </Box>
    </StickyTopRowStack>
  );
};

export default TotalMonitoringFilter;
